import { render, staticRenderFns } from "./CallEvaluation.vue?vue&type=template&id=88ae6952&scoped=true&"
import script from "./CallEvaluation.vue?vue&type=script&lang=js&"
export * from "./CallEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./CallEvaluation.vue?vue&type=style&index=0&id=88ae6952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ae6952",
  null
  
)

export default component.exports